import { Box } from "@mui/material"
import { styled } from '@mui/material/styles'

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '50vh',
    gap: theme.spacing(3),
    textAlign: 'center',
    px: 2,
}))

export const CenterBox: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <StyledBox>
            {children}
        </StyledBox>
    )
}